import styled from "styled-components/macro";
import { Heading3, Heading6 } from "styles/elements/Headings";
import { media } from "styles/media";
import type { ElearningTheme } from "themes/elearning.theme";

interface Props {
  theme: ElearningTheme;
}

export const TestsContainer = styled.div<Props>`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const CollapsibleContainer = styled.div<Props>`
  margin-bottom: 20px;
  width: 100%;
  > div:first-child {
    background-color: white;
  }
`;

export const Container = styled.div<Props>`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const StyleTitle = styled(Heading3)<Props>`
  margin-top: 52px;
`;

export const StyleText = styled(Heading6)<Props>`
  margin-top: 16px;
`;

export const FlashCardStyled = styled.div<Props>`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 24px;
  width: 100%;
  #super-submit-undefined {
    display: none;
  }
`;

export const StyleContainer = styled.div<Props>`
  display: flex;
  flex-direction: row;
  flex: 1;
  flex-wrap: wrap;
  margin: 0px auto 0px auto;
  max-width: initial;
  width: 80%;
  ${media.tablet} {
  display: flex;
  flex-direction: column;
  padding: 4px 0;
  width: 100vw;
  }
`;
